// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipOutlinedSvg from "@fishx/icons-svg/es/asn/FileZipOutlined";
import FishxIcon from '../components/FishxIcon';

var FileZipOutlined = function FileZipOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipOutlinedSvg
  }));
};

FileZipOutlined.displayName = 'FileZipOutlined';
export default React.forwardRef(FileZipOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileZipOutlined.js
// module id = 2763
// module chunks = 0